import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, IconButton, Dialog, DialogActions, DialogContent } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { usePages } from '../../hooks/usePages';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { Layout } from '../../components/Layout'

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';
import { DialogContentStyle, DialogActionsStyle } from '../../styles/DialogStyle';

import { DialogExpediente } from '../../dialogs/DialogExpediente';
import { DialogIrregular } from '../../dialogs/DialogIrregular';
import { DialogDocumento } from '../../dialogs/DialogDocumento';

import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerLibroAuxiliar, DescargarLibroAuxiliar, GuardarObservacionesLibroAuxiliar } from '../../connections/libros-electronicos/LibroAuxiliarConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { defaultLibroAuxiliar, LibroAuxiliarProps } from '../../interfaces/libros-electronicos/LibroAuxiliarInterfce';

export const LibroAuxiliarPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingDescarga, setLoadingDescarga] = useState( false );
    const [loadingObservaciones, setLoadingObservaciones] = useState( false );

    const [searching, setSearching] = useState( false );

    const [openDialogObservaciones, setOpenDialogObservaciones] = useState( false );
    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [openDialogIrregular, setOpenDialogIrregular] = useState( false );
    const [openDialogDocumento, setOpenDialogDocumento] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );
    const [recordCount, setRecordCount] = useState( 0 );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );
    const [documento, setDocumento] = useState( '' );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [libroAuxiliarSelected, setLibroSelected] = useState<LibroAuxiliarProps>( defaultLibroAuxiliar );

    const [rows, setRows] = useState<LibroAuxiliarProps[]>( [] );
    const [observaciones, setObservaciones] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setNumeroReferencia( '' );

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );

        setFiltroAplicado( false );

        resetPage();

    }

    const handleBuscar = async () => {

        setSearching( true );
        setLoading( true );
        setRecordCount( 0 );
        setRows( [] );
        setFiltroAplicado( true );

    };

    const handleDescargar = async () => {

        setLoadingDescarga( true );

        await DescargarLibroAuxiliar({ idAutoridad: autoridad, numeroReferencia }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile(`Libro-auxiliar-${Date.now()}.xlsx`, resp);

                    setLoadingDescarga( false );

                }
                else {

                    setLoadingDescarga( false );
                }

            }, 700);

        });

    }

    const handleOpenExpediente = ( value: LibroAuxiliarProps ) => {

        setLibroSelected( value );
        setOpenDialogExpediente( true );

    }

    const handleOpenIrregular = ( value: LibroAuxiliarProps ) => {

        setLibroSelected( value );
        setOpenDialogIrregular( true );

    }

    const handleOpenObservaciones = ( value: LibroAuxiliarProps ) => {

        setLibroSelected( value );
        setObservaciones( libroAuxiliarSelected.observaciones );
        setOpenDialogObservaciones( true );

    }

    const handleGuardarObservaciones = async () => {

        setLoadingObservaciones( true );

        await GuardarObservacionesLibroAuxiliar({ id: libroAuxiliarSelected.idLibroAuxiliar, observaciones }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setOpenDialogObservaciones( false );
                    setLoadingObservaciones( false );

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setLoadingObservaciones( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroAuxiliar({ idAutoridad: 0, numeroReferencia: '', page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, page, rowsPerPage ])

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroAuxiliar({ idAutoridad: autoridad, numeroReferencia, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );
                    setSearching( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, autoridad, numeroReferencia, page, rowsPerPage ])

    return (
        <Layout breadcrumbs={ [ { text: 'Libros electrónicos' }, { text: 'Libro de promociones irregulares y expedientillos auxiliares' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon />} color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }

                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter(({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth disabled={ materia === 0 || filtroAplicado }>

                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map(({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        autoComplete='off'
                                        variant='outlined'
                                        label='Número de irregular'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        value={ numeroReferencia }
                                        onChange={ (e) => { setNumeroReferencia(e.target.value) }}
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true, }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ searching }
                                        disabled={ autoridad === 0 && numeroReferencia.trim() === '' }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        loading={ loadingDescarga }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Irregular</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Acuerdo</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold', textAlign: 'center' }}>Parte(s)</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Observaciones</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold', textAlign: 'center' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map((elem, index) => {

                                        const { numeroIrregular, numeroExpediente, fechaAcuerdo, actor, demandado, acuerdo, observaciones } = elem;

                                        return <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleOpenIrregular( elem ) }
                                                >
                                                    { numeroIrregular }
                                                </Button>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => handleOpenExpediente( elem ) }
                                                >
                                                    { numeroExpediente }
                                                </Button>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    fechaAcuerdo
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fechaAcuerdo ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fechaAcuerdo ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                            {
                                                                acuerdo
                                                                &&
                                                                    <Button
                                                                        variant='contained'
                                                                        size='small'
                                                                        color='primary'
                                                                        sx={{ mt: 1 }}
                                                                        onClick={ () => { setDocumento( acuerdo ); setOpenDialogDocumento( true ); }}
                                                                    >
                                                                        Ver acuerdo
                                                                    </Button>
                                                            }

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                { actor.toLocaleUpperCase() }

                                                {
                                                    demandado !== ""
                                                    &&
                                                        <>
                                                            <br /> <strong>vs</strong> <br />

                                                            { demandado.toLocaleUpperCase() }
                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell> { observaciones } </TableCell>

                                            <TableCell>

                                                <IconButton color='primary' onClick={ () => handleOpenObservaciones( elem ) }>
                                                    <EditIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    })
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 73 }}>

                                            <TableCell colSpan={ 7 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={ 7 } align='center'>

                                                    <CircularProgress size={ 32 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 4 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDialogDocumento }
                handleCloseDialog={ () => setOpenDialogDocumento( false ) }
            />

            <DialogIrregular
                irregular={ libroAuxiliarSelected.irregular }
                openDialog={ openDialogIrregular }
                handleCloseDialog={ () => setOpenDialogIrregular( false ) }
            />

            <DialogExpediente
                expediente={ libroAuxiliarSelected.expediente }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogObservaciones }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 1 }}
                        label='Observaciones'
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ observaciones }
                        onChange={ (e) => setObservaciones( e.target.value ) }
                        slotProps={{
                            input: { autoComplete: 'off' },
                            inputLabel: { shrink: true }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingObservaciones } onClick={ () => setOpenDialogObservaciones( false ) }> Cancelar </Button>
                    <Button variant='contained' loading={ loadingObservaciones } onClick={ handleGuardarObservaciones }> Guardar </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}
